<template>
  <span class="chip" :class="setClassModifiers('chip--')">
    <slot></slot>
  </span>
</template>

<script>
import setClassModifiers from '@/mixins/setClassModifiers'

export default {
  mixins: [setClassModifiers],
  props: {
    color: {
      type: String,
      default: 'secondary'
    }
  }
}
</script>

<style lang="scss">
  @mixin chipColor($colorVar) {
    //background-color: lighten($colorVar, 45%);
    background: rgba($colorVar, 0.15);
    color: $colorVar;
  }
  .chip {
    font-weight: 500;
    padding: .4rem 1.5rem;
    border-radius: $border-radius-large;
    font-size: 1.2rem;

    @include chipColor($color-secondary);

    &--success {
      @include chipColor($color-success);
    }

    &--error {
      @include chipColor($color-error);
    }

    &--info {
      @include chipColor($color-info)
    }
  }
</style>
